export const GoogleSignin={
configure:()=>{

}
}

export const statusCodes={

}